import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  card: {
    padding: '1rem 0'
  },
  cardMain: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  cardTitle: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    fontSize: '18px'
  }
}));
